import React from 'react';

const Nodata = () => {
    return (
        <div>
            <h1 className='text-center fw-bold text-danger py-5'>404 Page Not Found!</h1>
        </div>
    );
};

export default Nodata;